var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D71924"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1484 26.8359H31.4195L38.9547 13.5779C39.1412 13.2513 39.1401 12.8506 38.9517 12.5251C38.7622 12.2 38.415 12 38.039 12H25.3828C24.9288 12 24.5259 12.2906 24.3828 12.721L18.0547 31.7756C17.9465 32.097 18.0011 32.4513 18.1989 32.7262C18.3977 33.0014 18.716 33.164 19.0547 33.164H28.0022L22.3044 46.5302C22.1004 47.0051 22.2715 47.5583 22.7082 47.8351C23.1378 48.1098 23.7148 48.0375 24.0614 47.6459L40.9364 28.5912C41.2124 28.2811 41.2805 27.837 41.1105 27.4591C40.9405 27.0801 40.5637 26.8359 40.1484 26.8359Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon_06.692fbc10680e1b9d81617325037434a2.svg";
export { ForwardRef as ReactComponent };